
import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosInstance";
import PageTitle from "../../components/PageTitle";
import PageLoadingSpinner from "../../components/PageLoading";

import formatToLocaleDate from "../../helpers/dateTimeConverter"



export default function DemoLeads() {
    const [loading, setLoading] = useState(true);
    const [leads, setLeads] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);

    const getLeads = async () => {
        try{
            const response = await axiosInstance.get(`/admin/leads/demoleads`);
            setLeads(response.data.leads);
        } catch(error){
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const openModal = (lead) => {
        setSelectedLead(lead);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedLead(null);
    };

    useEffect(() =>{
        getLeads();
    },[])

    if(loading){
        return (
            <PageLoadingSpinner />
        )
    }

    return (
        <>

            <PageTitle title={"Demo Leads"}/>

            <div className="flex justify-between mb-5">
                <h2 className="font-bold text-xl text-gray-900 dark:text-gray-100">Demo Leads</h2>
            </div>

            <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y-2 divide-gray-200 dark:divide-gray-700">
                        <thead className="text-left bg-gray-50 dark:bg-gray-700">
                        <tr className="uppercase text-sm" >
                            <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Full Name</th>
                            <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Website</th>
                            <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Email</th>
                            <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Contact</th>
                            <th className="whitespace-nowrap px-4 py-2 text-gray-700 dark:text-gray-300">Created At</th>
                        </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                        {leads && leads.length > 0 ? (
                            leads.map(lead => (
                                <tr className="capitalize hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer" key={lead.id} onClick={() => openModal(lead)}>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-900 dark:text-gray-100">{lead.fullname}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-900 dark:text-gray-100">{lead.website}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-900 dark:text-gray-100">{lead.email}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-900 dark:text-gray-100">{lead.contact}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-900 dark:text-gray-100">{formatToLocaleDate(lead.createdAt)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="px-4 py-2 text-center text-gray-500 dark:text-gray-400">No leads found.</td>
                            </tr>
                        )}

                        </tbody>
                    </table>
                </div>
            </div>


            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl mx-4">
                        <h3 className="text-lg font-bold mb-4 text-gray-900 dark:text-gray-100">Lead Details</h3>
                        {selectedLead && (
                            <div className="space-y-3 text-gray-700 dark:text-gray-300">
                                <p><strong className="text-gray-900 dark:text-gray-100">Full Name:</strong> {selectedLead.fullname}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Website:</strong> {selectedLead.website}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Email:</strong> {selectedLead.email}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Contact:</strong> {selectedLead.contact}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Industry:</strong> {selectedLead.industry}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Inquiry:</strong> {selectedLead.inquiry}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Demo Date time:</strong> {selectedLead.demodate}</p>
                                <p><strong className="text-gray-900 dark:text-gray-100">Created At:</strong> {formatToLocaleDate(selectedLead.createdAt)}</p>
                            </div>
                        )}
                        <div className="mt-6 flex justify-end gap-2">
                            <button
                                className="px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-600 transition"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}